export default class LogoScroll {
  constructor() {
    this.logo = document.querySelector('.g-logo');
    if (!this.logo) return;

    this.lastScrollY = window.pageYOffset;
    this.ticking = false;
    this.scrollTimeout = null;
    this.hideTimeout = null;
    this.pauseTimeout = null;

    this.handleScroll = this.handleScroll.bind(this);
    this.onScrollPause = this.onScrollPause.bind(this);
    this.onScrollStop = this.onScrollStop.bind(this);

    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }

    // Detect temporary pauses in scrolling (300ms inactivity) to clear hide timer early
    if (this.pauseTimeout) {
      clearTimeout(this.pauseTimeout);
    }
    this.pauseTimeout = setTimeout(this.onScrollPause, 300);

    // Debounce complete scroll stop (1000ms inactivity to show the logo again)
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(this.onScrollStop, 1000);
  }

  update() {
    const currentScrollY = window.pageYOffset;
    
    // Only animate if scrolled down past a small threshold (e.g., 50px) to avoid issues near top of page
    if (currentScrollY > 50) {
      if (currentScrollY > this.lastScrollY) {
        // Scrolling down -> wait for 0.6s of continuous scroll before hiding
        if (!this.hideTimeout) {
          this.hideTimeout = setTimeout(() => {
            this.logo.classList.add('is-scroll-down');
          }, 600);
        }
      } else if (currentScrollY < this.lastScrollY) {
        // Scrolling up -> cancel hide timer and show logo immediately
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }
        this.logo.classList.remove('is-scroll-down');
      }
    } else {
      // Near top of page -> always show the logo immediately
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.logo.classList.remove('is-scroll-down');
    }

    this.lastScrollY = currentScrollY;
  }

  onScrollPause() {
    // If user stops scrolling down, cancel any pending hide timer
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }

  onScrollStop() {
    // Scrolling stopped for 1s -> show the logo (translate is none, fade in)
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    this.logo.classList.remove('is-scroll-down');
  }
}
